var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-select',{attrs:{"items":_vm.data,"item-text":"title","item-value":"value","autocomplete":false,"prepend-inner-icon":"fas fa-bars","hide-details":1},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }